// =============================================================================
// src/lib/auditArgs.js
// Shapes the arguments of the log_audit RPC so a bad id can never lose the row.
//
// log_audit(p_entity_id uuid, p_patient_id uuid, ...) is called through
// PostgREST. When a caller passes something that is not a UUID (Oct 2026: the
// consent-renewal button on the worklist passed the 12-character consent link
// token), PostgREST rejects the whole call with 22P02 / HTTP 400 and NO audit
// row is written. logAudit only console.warns, so the gap is silent.
//
// The rule: an id that is not a UUID is sent as null and the row is kept,
// with details.entity_ref_dropped / patient_ref_dropped = true so the gap is
// visible in the audit log. The dropped value itself is never copied into
// details: it may be a bearer credential (a consent or reschedule link token).
// Guarded by src/lib/__tests__/auditArgs.test.mjs.
// =============================================================================

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUuid(v) {
  return typeof v === "string" && UUID_RE.test(v);
}

// Returns the p_* argument object for the log_audit RPC.
export function auditRpcArgs({ action, entityType, entityId = null, patientId = null, details = {}, success = true, error = null }) {
  let d = details && typeof details === "object" && !Array.isArray(details) ? details : {};
  let eid = entityId == null || entityId === "" ? null : entityId;
  let pid = patientId == null || patientId === "" ? null : patientId;
  if (eid !== null && !isUuid(eid)) {
    eid = null;
    d = { ...d, entity_ref_dropped: true };
  }
  if (pid !== null && !isUuid(pid)) {
    pid = null;
    d = { ...d, patient_ref_dropped: true };
  }
  return {
    p_action:      action,
    p_entity_type: entityType,
    p_entity_id:   eid,
    p_patient_id:  pid,
    p_details:     d,
    p_success:     success,
    p_error:       error,
  };
}
